export const LOCAL_STORAGE_SAVED_CITY_KEY = 'savedCity';
